import axios from "axios";

import getConfig from "../conf/config";
import { auth } from "../conf/firebase";

const myAxios = axios.create({
  baseURL: getConfig().API_URL,
});

myAxios.interceptors.request.use(
  async (config) => {
    const { currentUser } = auth; // Get the current user

    if (!currentUser || currentUser === null) {
      // Return the config as is if no user is signed in
      return config;
    }

    const idToken = await currentUser.getIdToken(true); // Get the ID token
    return {
      ...config,
      headers: {
        Authorization: `Bearer ${idToken}`, // Attach the ID token to the Authorization header
        ...config.headers,
      },
    };
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default myAxios;
